import React from 'react';
import './StartMenu.css';

const StartMenu = ({ isOpen, onClose, onOpenApp, onSleep }) => {
  if (!isOpen) return null;

  const apps = [
    { id: 'home', name: 'Home', icon: '/assets/icons/computer.png' },
    { id: 'about', name: 'About Me', icon: '/assets/icons/documents.png' },
    { id: 'services', name: 'Services', icon: '/assets/icons/folder.png' },
    { id: 'contact', name: 'Contact Me', icon: '/assets/icons/mail.png' },
  ];

  return (
    <>
      <div className="start-menu-overlay" onClick={onClose} />
      <div className="start-menu">
        <div className="start-menu-header">
          <h3>Pages</h3>
        </div>
        <div className="start-menu-apps">
          {apps.map((app) => (
            <button
              key={app.id}
              className="start-menu-app"
              onClick={() => {
                onOpenApp(app);
                onClose();
              }}
            >
              <span className="app-icon">
                <img src={app.icon} alt="" />
              </span>
              <span className="app-name">{app.name}</span>
            </button>
          ))}
        </div>
        <div className="start-menu-footer">
          <button className="power-button" onClick={onSleep}>
            <img src="/assets/icons/sleep.ico" alt="Sleep" className="sleep-icon" />
            Sleep
          </button>
        </div>
      </div>
    </>
  );
};

export default StartMenu;
